export const GET_USERS_REQUESTED = 'GET_SEARCH_REQUESTED';
export const GET_USERS_SUCCESS = 'GET_SEARCH_SUCCESS';
export const GET_USERS_FAILED = 'GET_SEARCH_FAILED';

export const GET_FAVOURITE_SUCCESS = 'GET_FAVOURITE_SUCCESS';
export const GET_FAVOURITE_FAILED = 'GET_FAVOURITE_FAILED';
export const GET_FAVOURITE_REQUESTED = 'GET_FAVOURITE_REQUESTED'